export function deviceDetect() {
  return {
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    isDesktop: !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    isAndroid: /Android/i.test(navigator.userAgent),
    isIos: /iPhone|iPad|iPod/i.test(navigator.userAgent),
    isWechat: /MicroMessenger/i.test(navigator.userAgent),
    isAlipay: /Alipay/i.test(navigator.userAgent),
    isMiniProgram: /miniProgram/i.test(navigator.userAgent),
    isPc: /Windows|Macintosh/i.test(navigator.userAgent),
    isChrome: /Chrome/i.test(navigator.userAgent),
    isSafari: /Safari/i.test(navigator.userAgent),
    isFirefox: /Firefox/i.test(navigator.userAgent),
  };
}
